<template>
  <v-server-table
    :url="url"
    :columns="columns"
    :options="options"
    class="trigger"
    ref="table"
  >
    <template slot="trajectory_project_name" slot-scope="props">
      {{ props.row.trajectory_project.name }}
    </template>
    <template slot="trajectory_name" slot-scope="props">
      
      <link-if
        :if="
          $hasRole('super_admin') ||
            $hasRole('trajectory_administrator') ||
            $hasRole('trajectory_manager') ||
            $hasRole('trajectory_inspector')
        "
        :to="{
          name: 'admin.relations.trajectory-enrolments.view',
          params: {
            relationId: props?.row?.relation_id,
            trajectoryEnrolmentId: props?.row?.id,
          },
        }"
        >{{ props?.row?.trajectory?.name || '-' }}
      </link-if>
      
      <!-- Keep this in case they want to show it in the future, for quick reference -->
      <i v-if="false && props?.row?.duplicate_from_id" 
        class="fa fa-copy fa text-muted" 
        style="width: auto !important;" 
        :title="uLang('app.duplicated_enrolment') + ': ' + props?.row?.duplicate_from_id">
      </i>
    </template>
    <template slot="trajectory_manager" slot-scope="{ row }">
      <b-badge
        pill
        variant="primary"
        v-if="row.trajectory_manager && row.trajectory_manager_id"
      >
        <link-if
          :if="!$hasType('client')"
          :to="{
            name: 'admin.relations.view',
            params: { id: row.trajectory_manager.id },
          }"
        >
          {{ row.trajectory_manager.full_name }}
        </link-if>
      </b-badge>
      <span v-else>
        -
      </span>
    </template>
    <template slot="status" slot-scope="props">
      <b-badge pill variant="primary">{{
        uLang("app." + props.row.trajectory_enrolment_status.name)
      }}</b-badge>
    </template>
    <template slot="filter__status">
      <multi-select
        :options="statuses"
        :loading="!statuses"
        :deselectLabel="uLang('app.press_enter_to_remove')"
        :selectLabel="uLang('app.press_enter_to_select')"
        :selectedLabel="uLang('app.select')"
        label="translated_name"
        :placeholder="uLang('app.select_an_option')"
        @input="searchStatus"
        track-by="name"
      />
    </template>
    <template slot="time_log" slot-scope="{ row }">
        <span>{{ row.time_log | duration }}</span>
    </template>
  </v-server-table>
</template>

<script>
import MultiSelect from "vue-multiselect/src/index";
import Actions from "./actions";
import { TableMixin } from "~/mixins";

export default {
  name: "index",
  mixins: [TableMixin],
  components: {
    "multi-select": MultiSelect,
  },

  props: {
    url: {
      type: String,
      required: true,
      default: null,
    },
  },

  data() {
    return {
      statuses: [],
      columns: [
        "trajectory_project_name",
        "trajectory_name",
        "trajectory_manager",
        "status",
        'time_log',
        "actions",
      ],
      filterable: [
        "trajectory_project_name",
        "trajectory_name",
        "trajectory_manager",
        // 'status',
      ],
      templates: {
        actions: Actions,
      },
      options: {
        headings: {
          trajectory_project_name: this.uLang("app.trajectory_project"),
          trajectory_name: this.uLang("app.trajectory"),
          trajectory_manager: this.uLang("app.trajectory_manager"),
          status: this.uLang("app.status"),
          time_log: this.uLang('app.total_duration'),
          actions: this.uLang("app.actions"),
        },
        customFilters: ["status"],
      },
    };
  },

  created() {
    this.retrieveStatuses();
  },

  methods: {
    async retrieveStatuses() {
      const { data } = await window.axios.get(
        route("trajectory-enrolment-statuses.index")
      );
      this.statuses = data;
    },

    searchStatus(status) {
      this.$refs.table.query.status = status !== null ? status.name : "";
      this.$refs.table.refresh();
    },
  },
};
</script>

<style lang="css" scoped></style>
